export class ContactMap {
    constructor(element) {

        // note: MapData is a wp_localize_script object with latlng, address, icon_dir (icon images directory)
        // see lib/scripts.php
        // Since opening the new office, we need to pull out the right LatLng - so query the "office" var
        const office_latlng = window.MapData.latlng;
        const latlng_array = office_latlng.split(',');
        const lat = Number(latlng_array[0]);
        const lng = Number(latlng_array[1]);
        const latlng = new google.maps.LatLng(lat, lng);
        const center_latlng = new google.maps.LatLng(lat, lng);
        const options = {
            zoom: 15,
            center: center_latlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            zoomControl: true,
            panControl: true
        };

        const gmap = new google.maps.Map(document.getElementById("map"), options);
        new google.maps.Marker({
            position: latlng,
            map: gmap
        });

        setTimeout(function () {
            if (window.location.hash) {
                window.scrollTo(0, 0);
            }
        }, 1);
    }
}